import { Outlet } from 'react-router';
import styles from './PublicLayout.module.css';

/**
 * The frame for signed-out pages (welcome, sign-up, sign-in, info): no
 * navigation, one `<main>`, a narrow column like the Android onboarding.
 */
export function PublicLayout() {
  return (
    <main id="main" tabIndex={-1} className={styles.main}>
      <Outlet />
    </main>
  );
}
